import type { ReactNode } from 'react';

import { TabsTruot } from '../../../../components/shared';

export interface MucTab {
  key: string;
  label: string;
  children: ReactNode;
}

/**
 * Thanh tab của các màn Nhật ký & Truy vết — native tự dựng một dải viên tab; ở platform dựng trên `TabsTruot`
 * (ADR-UI-0008: khung `surface`, thẻ đang mở tô nền nhấn, nội dung trượt), để màn này giống mọi màn có tab khác.
 *
 * Giữ hai việc của bản native:
 * - chỉ dựng nội dung của tab ĐANG MỞ (`TabsTruot` làm sẵn): mỗi tab là một truy vấn riêng;
 * - `phai`: chỗ cho bộ điều khiển áp cho MỌI tab (khoảng thời gian, làm mới), cùng hàng với thẻ — để người dùng thấy
 *   nó không thuộc riêng tab nào.
 *
 * ⚠️ `TabsTruot` giữ tab đang mở trong state riêng: `macDinh` chỉ đọc lúc dựng. Màn nào đồng bộ tab với `?tab=` thì
 * đọc URL làm `macDinh` và ghi URL trong `onChange` — đổi URL từ ngoài khi đang ở màn thì đặt `key` cho `ThanhTab`.
 */
export function ThanhTab({
  macDinh,
  onChange,
  items,
  phai,
  nhan,
}: {
  macDinh?: string;
  onChange?: (key: string) => void;
  items: readonly MucTab[];
  phai?: ReactNode;
  /** Tên của nhóm tab cho trình đọc màn hình. */
  nhan: string;
}) {
  return (
    <section aria-label={nhan}>
      {/*
        Hết chỗ (768px, nhất là cổng nền tảng có thêm ô chọn tenant) thì bộ điều khiển `phai` xuống dòng riêng dưới hàng
        thẻ, còn thẻ tự xuống dòng (`xuongDong`) — mặc định antd dồn thẻ vào menu "…" và giấu luôn thẻ đang mở. Hàng thẻ
        giữ tối thiểu đủ cho bốn thẻ trên một dòng khi khung đủ rộng, nên ở 1280px mọi thứ vẫn cùng một hàng.
      */}
      <TabsTruot
        xuongDong
        className="[&>.ant-tabs-nav>.ant-tabs-nav-wrap]:min-w-[min(100%,34rem)] [&>.ant-tabs-nav]:flex-wrap [&>.ant-tabs-nav]:gap-2 [&>.ant-tabs-nav>.ant-tabs-extra-content]:ml-auto [&>.ant-tabs-nav>.ant-tabs-extra-content]:max-w-full"
        items={items.map((m) => ({ key: m.key, label: m.label, children: m.children }))}
        defaultActiveKey={macDinh}
        onChange={onChange}
        tabBarExtraContent={
          phai ? { right: <div className="flex flex-wrap items-center justify-end gap-2">{phai}</div> } : undefined
        }
      />
    </section>
  );
}
